import {
  isEligibleAutopayPaymentMethod,
} from "../../PaymentMethods/utils";

export type AutopayPaymentMethodOption = {
  id: string;
  display: string;
  providerName: string;
  last4: string;
  type: string;
  status?: string | null;
  expiryDate?: string | null;
};

export const buildAutopayEnrollmentPaymentMethodOptions = (
  paymentMethods: AutopayPaymentMethodOption[]
) =>
  paymentMethods
    .filter(isEligibleAutopayPaymentMethod)
    .map((paymentMethod) => (
      <option key={paymentMethod.id} value={paymentMethod.id}>
        {paymentMethod.display}
      </option>
    ));

export const buildAutopayChangeSourcePaymentMethodOptions = (
  paymentMethods: AutopayPaymentMethodOption[],
  selectedPaymentMethodId?: string | null
) =>
  paymentMethods
    .filter(
      (paymentMethod) =>
        isEligibleAutopayPaymentMethod(paymentMethod) ||
        paymentMethod.id === selectedPaymentMethodId
    )
    .map((paymentMethod) => {
      const eligible = isEligibleAutopayPaymentMethod(paymentMethod);

      return (
        <option
          key={paymentMethod.id}
          value={paymentMethod.id}
          disabled={!eligible}
        >
          {paymentMethod.display}
        </option>
      );
    });
